var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/nodes/doc.ts
import "@adornis/buildify/client/components/x-buildify-size-picker";
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element.js";
import { ComponentSizeController } from "@adornis/chemistry/controllers/component-size-controller.js";
import { RXController } from "@adornis/chemistry/controllers/RXController.js";
import { xComponents } from "@adornis/chemistry/elements/x-components.js";
import { ContextProvider, createContext } from "@lit/context";
import { html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { combineLatest, debounceTime, distinctUntilChanged, filter, map } from "rxjs";
import { Contexts, Size } from "../../db/enums.js";
import { DOC_SCHEMA } from "../../schema/nodes/doc.js";
var doc = () => ({
  node: {
    name: "doc",
    schema: DOC_SCHEMA()
  }
});
var NodeDoc = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this.mode = new RXController(this, "view");
    this.globalSettingsClassName = new RXController(
      this,
      void 0
    );
    this.sizeBreakpoints = new RXController(
      this,
      void 0
    );
    this._componentSizeController = new ComponentSizeController(this, { triggerUpdates: false });
    this._modeProvider = new ContextProvider(this, {
      context: createContext(Contexts.MODE)
    });
    this._sizeProvider = new ContextProvider(this, {
      context: createContext(Contexts.SIZE)
    });
    this._globalSettingsClassNameProvider = new ContextProvider(this, {
      context: createContext(Contexts.GLOBAL_SETTINGS_CLASS_NAME)
    });
  }
  connectedCallback() {
    super.connectedCallback();
    combineLatest([this.sizeBreakpoints.observable, this._componentSizeController.observable]).pipe(
      debounceTime(250),
      distinctUntilChanged(),
      map(([_, sizeController]) => {
        return sizeController.width;
      })
    ).subscribe((width) => {
      const sizeBreakpoints = this.getSizeBreakpoints();
      if (!sizeBreakpoints)
        return;
      const sizeProvider = this._sizeProvider;
      if (!sizeProvider)
        return;
      if (width <= sizeBreakpoints[Size.MOBILE])
        return sizeProvider.setValue(Size.MOBILE, true);
      if (width <= sizeBreakpoints[Size.TABLET])
        return sizeProvider.setValue(Size.TABLET, true);
      return sizeProvider.setValue(Size.DESKTOP, true);
    }).add(() => {
      this.requestUpdate();
    });
    this.mode.observable.pipe(filter(Boolean)).subscribe((mode) => {
      this._modeProvider.setValue(mode, true);
    });
  }
  render() {
    return xComponents(html` <slot></slot> `);
  }
  getSizeBreakpoints() {
    const sizeBreakpointsJSONString = this.sizeBreakpoints.value;
    const sizeBreakpoints = sizeBreakpointsJSONString ? JSON.parse(sizeBreakpointsJSONString) : void 0;
    return sizeBreakpoints;
  }
  styles() {
    return [
      ...super.styles(),
      {
        ":host": {
          display: "block",
          minWidth: "0",
          border: this.mode.value === "edit" ? "1px solid rgb(221, 221, 221)" : ""
        }
      }
    ];
  }
};
__decorateClass([
  property({ attribute: "mode", type: String })
], NodeDoc.prototype, "mode", 2);
__decorateClass([
  property({ attribute: "global-settings-class-name", type: String })
], NodeDoc.prototype, "globalSettingsClassName", 2);
__decorateClass([
  property({ attribute: "size-breakpoints", type: String })
], NodeDoc.prototype, "sizeBreakpoints", 2);
NodeDoc = __decorateClass([
  customElement("node-doc")
], NodeDoc);
export {
  NodeDoc,
  doc
};
